/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var dropParent = '';
var dropDepth = 0;
var getDropParent = function getDropParent(_ref) {
  var ranges = _ref.ranges,
    dragBoxRegion = _ref.dragBoxRegion;
  var boxTop = dragBoxRegion.top;
  ranges.filter(function (row) {
    if (boxTop >= row.top && boxTop <= row.bottom) {
      dropParent = row.keyPath;
      dropDepth = row.depth;
    }
  });
  return {
    dropParent: dropParent,
    dropDepth: dropDepth
  };
};
var _default = getDropParent;
exports.default = _default;